import {Location} from "@angular/common";
import { environment } from "src/environments/environment";

export namespace AppConfig {

  export function apiUrl(paths) {
    return Location.joinWithSlash(environment.api_url, paths)
  }
}
